(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.project.openGateReport', {
      url: '/open-gate-report',
      template: `<new-front-container path="'open-gate-report'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.OpenGateReport" | translate}}',
      },
    });
  }
})();
